import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { http } from "@/lib/api";

export default function VenduOneClickPage() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    http.get(`/annonces/vendu-oneclick/${token}`).then((r) => setState({ ok: true, ...r.data })).catch((e) => setState({ ok: false, error: e.response?.data?.detail || "Lien invalide" }));
  }, [token]);
  return (
    <main className="max-w-lg mx-auto px-6 py-20 text-center" data-testid="vendu-oneclick-page">
      {state.loading ? <Loader2 className="animate-spin mx-auto text-orange-500" /> : state.ok ? (
        <>
          <CheckCircle2 size={48} className="mx-auto text-emerald-600" />
          <h1 className="mt-4 text-2xl font-extrabold">Felicitations, c'est vendu !</h1>
          <p className="mt-2 text-sm text-[var(--ink-soft)]">« {state.title} » porte desormais le badge VENDU. Vous pouvez la garder affichee ou la supprimer depuis Mes annonces.</p>
          <Link to="/mes-annonces" className="btn-primary inline-flex mt-6" data-testid="vendu-oneclick-mes-annonces">Gerer mes annonces</Link>
        </>
      ) : (
        <>
          <XCircle size={48} className="mx-auto text-red-500" />
          <h1 className="mt-4 text-xl font-extrabold">{state.error}</h1>
          <Link to="/mes-annonces" className="btn-secondary inline-flex mt-6">Aller a Mes annonces</Link>
        </>
      )}
    </main>
  );
}
